// removed by extract-text-webpack-plugin
module.exports = {"circle":"_3J12-qKmZPV5CmHHLQMcOR"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/v2/atoms/FontIcon/additionals.css
// module id = 461
// module chunks = 38